import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/game/Home";
import Lobby from "./pages/game/Lobby";
import Game from "./pages/game/Game";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import NotFoundPage from "./pages/NotFoundPage";
import setupVhFallback from "./lib/viewportVh";
import ScrollToTop from "./styleguide/atoms/scroll-top/ScrollToTop";
import { ensureAnonAuth } from "./firebase";

class App extends Component {
  teardown = null;
  async componentDidMount() {
    this.teardown = setupVhFallback();
    await ensureAnonAuth();
  }
  componentWillUnmount() {
    if (this.teardown) this.teardown();
  }

  render() {
    return (
      <Router>
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/lobby/:gameId" component={Lobby} />
            <Route exact path="/game/:gameId" component={Game} />
            <Route exact path="/privacy" component={PrivacyPolicy} />
            <Route exact path="/terms-of-service" component={TermsOfService} />
            <Route path="*">
              <NotFoundPage />
            </Route>
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;
